import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const PinterestHeadlineToolTip = (props) => (
  <div>
    The title of the break featured on the top.
    <br/>
    <img src={makeToolTipUrl('pinterest/1.CMS-pinterest-headline.png')} width="100%"/>
  </div>
);

export const PinterestIntroCopyToolTip = (props) => (
  <div>
    Copy to introduce the break.
    <br/>
    <img src={makeToolTipUrl('pinterest/2.CMS-pinterest-intro.png')} width="100%"/>
  </div>
);

export const PinterestDisplayTypeToolTip = (props) => (
  <div>
    If Pins, individual Pinterest items will appear. If Board, a whole Pinterest board will appear.
    <br/>
    <img src={makeToolTipUrl('pinterest/3.CMS-pinterest-pins.png')} width="100%"/>
    <img src={makeToolTipUrl('pinterest/4.CMS-pinterest-board.png')} width="100%"/>
  </div>
);

export const PinterestPinIDsToolTip = (props) => (
  <div>
    The last set of numbers on the URL. ex: https://www.pinterest.com/pin/<b>168603579779561957</b>/ When adding multiple, separate with commas. For best experience, use pins that are similar in height.
  </div>
);

export const PinterestBoardURLToolTip = (props) => (
  <div>
    The full URL of the board you want to feature. Ex: <b>https://www.pinterest.com/dailybreak/home-garden/</b> If interested in creating new Pinterest content, the board must first be made on the Dailybreak Pinterest board.
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/pinterest-tool-tips.jsx